import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { postInstoreCardLink } from 'core/actions/member';
import { selectEasyLinkSuppression } from 'core/selectors/user';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { useApiFeedbackManager } from 'core/hooks/useApiFeedbackManager';
import { selectDynamicCardLinksFeedback } from 'core/modules/Instore2/selectors';
import { clearInstoreLinkFailure } from 'core/modules/Instore2/actions';
import { ME_PAGE_INSTORE } from 'core/modules/Instore2/utils/constants';
import {
  InstoreRebate, LinkWarning, Disclaimer, LinkOfferButton, ManageCardsButton, UnlinkSuccessMessage,
} from 'core/modules/Instore2/partials';
import { InstoreMotto, useToggleDetailsButton } from '../partials';

import config from '../configs';

function WithoutLinkedCardsView({ offer, isOpenByDefault }) {
  const dispatch = useDispatch();
  const { disclaimer, offerId, rclonMerchantName } = offer;
  const { disclaimerTitle } = config;
  const dynamicCardLinksFeedback = useSelector(selectDynamicCardLinksFeedback);
  const easyLinkSuppression = useSelector(selectEasyLinkSuppression);

  const { ToggleDetailsButton, toggleDetails, isDetailsExpanded } = useToggleDetailsButton(isOpenByDefault);
  const { clearFeedback, feedbackData } = useApiFeedbackManager({
    data: dynamicCardLinksFeedback,
    callbackAction: clearInstoreLinkFailure,
  });

  const { hasLinkFailedFeedback, hasUnlinkSuccessFeedback } = feedbackData;

  useEffect(() => {
    if (hasUnlinkSuccessFeedback && !isDetailsExpanded) {
      toggleDetails();
    }
  }, [hasUnlinkSuccessFeedback]);

  useEffect(() => {
    if (!easyLinkSuppression) {
      // autolink offer
      dispatch(postInstoreCardLink(offerId, {}, {}, { autoLink: true, initiator: ME_PAGE_INSTORE, offer }));
    }
  }, [easyLinkSuppression]);

  return (
    <div
      id="instore"
      className="mn_meInstoreOffer mn_withoutLinkedCardsView"
      data-merchant-name={rclonMerchantName}
    >
      <LinkWarning hasError={hasLinkFailedFeedback} />
      <div className="mn_mainDetails">
        <div className="mn_leftSection">
          <InstoreMotto />
          <InstoreRebate offer={offer} />
        </div>
        <div className="mn_rightSection">
          <LinkOfferButton offer={offer} onClickCallback={clearFeedback} initiator={ME_PAGE_INSTORE} />
          <ToggleDetailsButton toggleDetails={toggleDetails} isDetailsExpanded={isDetailsExpanded} />
        </div>
      </div>
      {isDetailsExpanded &&
        <div className="mn_moreDetails">
          <div className="mn_buttons"><ManageCardsButton /></div>
          <UnlinkSuccessMessage hasMessage={hasUnlinkSuccessFeedback} />
          <Disclaimer title={disclaimerTitle}>{disclaimer}</Disclaimer>
        </div>
      }
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><WithoutLinkedCardsView {...props} /></ComponentErrorBoundary>;
